import React, { useState, useEffect } from 'react';

/**
 * Update Notification Component
 * 
 * Zeigt eine Benachrichtigung an, wenn ein neuer Service Worker verfügbar ist
 */
export default function UpdateNotification() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    // Check for service worker updates
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60000); // Every minute

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available
              setWaitingWorker(newWorker);
              setShowUpdate(true);
            }
          });
        });
      });

      // Listen for controller change (new SW activated)
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    }
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      // Tell waiting SW to skip waiting and activate
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdate(false);
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div style={styles.container}>
      <div style={styles.notification}>
        <div style={styles.content}>
          <div style={styles.icon}>🔄</div>
          <div style={styles.text}>
            <strong>Update verfügbar</strong>
            <p>Eine neue Version der App ist verfügbar.</p>
          </div>
        </div>
        <div style={styles.buttons}>
          <button onClick={handleUpdate} style={styles.updateButton}>
            Aktualisieren
          </button>
          <button onClick={handleDismiss} style={styles.dismissButton}>
            Später
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10000,
    maxWidth: '400px',
    width: '90%',
  },
  notification: {
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    padding: '1rem',
    border: '2px solid #4f46e5',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '1rem',
  },
  icon: {
    fontSize: '2rem',
  },
  text: {
    flex: 1,
  },
  buttons: {
    display: 'flex',
    gap: '0.5rem',
  },
  updateButton: {
    flex: 1,
    padding: '0.75rem',
    background: '#4f46e5',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  dismissButton: {
    flex: 1,
    padding: '0.75rem',
    background: '#e5e7eb',
    color: '#374151',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};
